<template>
  <div class="row">
    <div class="col-12 d-flex align-items-center flex-wrap gap-2">
      <h2 class="mb-0">{{ $t('general_terms.edit') }}</h2>
      <router-link class="btn btn-outline-secondary btn-sm"
                   :to="{name: ROUTES.GENERAL_TERMS.SHOW, params: {id: $route.params.id}}">
        {{ $t('general_terms.show_without_saving') }}
      </router-link>
    </div>

    <div class="col-12 mt-4">
      <form class="row" @submit.prevent="updateGeneralTerm">
        <FormFields v-model:formData="formData" :key-readonly="true"/>
        <div class="col-12 col-lg-3 mt-3">
          <button class="btn btn-success" type="submit" :disabled="saving">
            {{ $t('save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {useGeneralTermStore} from "@/stores/general_term";
import {Helpers} from "@/helpers";
import {ROUTES} from "@/scripts/constants";
import FormFields from "@/pages/general_terms/components/FormFields.vue";

function contentAsMarkdown(content) {
  if (typeof content === 'string') {
    return content
  }
  if (content && typeof content === 'object') {
    return JSON.stringify(content, null, 2)
  }
  return ''
}

export default {
  name: 'GeneralTermsEdit',
  components: {
    FormFields,
  },
  setup() {
    return {
      generalTermStore: useGeneralTermStore(),
    }
  },
  data() {
    return {
      formData: {
        key: '',
        title: '',
        content: '',
      },
      saving: false,
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    },
  },
  created() {
    this.generalTermStore.show(this.$route.params.id).then(() => {
      const generalTerm = this.generalTermStore.general_term
      if (generalTerm?.locked_at) {
        this.$router.replace({name: ROUTES.GENERAL_TERMS.SHOW, params: {id: this.$route.params.id}})
        return
      }
      this.formData = {
        key: generalTerm.key || '',
        title: generalTerm.title || '',
        content: contentAsMarkdown(generalTerm.content),
      }
      this.setTitle(this.$t('general_terms.edit'))
    })
  },
  methods: {
    buildPayload() {
      return {
        title: this.formData.title,
        content: this.formData.content,
      }
    },
    updateGeneralTerm() {
      this.saving = true
      this.generalTermStore.update(this.$route.params.id, this.buildPayload()).then(() => {
        Helpers.emitter.emit('success', this.$t('general_terms.updated'))
        this.$router.push({name: ROUTES.GENERAL_TERMS.SHOW, params: {id: this.$route.params.id}})
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>
